<template>
  <div class="box">
    <div class="topLine">
      <div class="l">
        <img src="@/assets/img/1.png" alt="">
        <div>
          <h5>医师姓名：{{ this.userInfo.realName }}</h5>
          <p>{{ this.userInfo.phone }}</p>
        </div>
        <div class="tabs">
          <el-link v-for="item in tabL" :key="item.val"  @click="handleClick(item)" :class="tabAct==item.val?'act':''" :underline="tabAct==item.val">{{item.name}}</el-link> 
        </div>
      </div>
      <div class="r">
        <div class="tabs">
          <el-link v-for="item in tabR" :key="item.val" :class="tabAct==item.val?'act':''"  :underline="tabAct==item.val" @click="handleClick(item)">{{item.name}}</el-link> 
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import * as echarts from 'echarts';
import { MessageBox } from 'element-ui';
export default {
  name: "tradiInfo",
  data(){
    return {
      tabAct:'',
      tabL:[
        {name:'中西会诊',val:'/tradiIndexPage'}, 
        {name:'我的患者',val:'/myPatientsT'}, 
      ],
      tabR:[
        {name:'个人信息',val:'/doctorInfoT'},
        {name:'我的收藏',val:'/myCollectionT'} ,
        {name:'我的购物车',val:'/carT'},
        {name:'我的订单',val:'/myOrderT'},
        {name:'我的地址管理',val:'/myAddressT'} 
      ]
    }
  },
  computed:{

  },
  watch:{
    '$route'(to, from) {
      this.handelInitTab() 
    }
  },
  created(){ 
    this.handelInitTab()
  },
  mounted(){ 
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    } 
  },
  methods:{
    handleClick(item){  
      sessionStorage.setItem("doctorTab",item.val)
      this.$router.push({
        path: item.val
      });
    },
    handelInitTab(){
      let str = ''
      let arr = [] 
      if(window.location.hash){
        arr = window.location.hash.split('#')
      } 
      if(arr && arr.length>1){
        str = arr[1]
        sessionStorage.setItem("doctorTab",str )
      } 
      this.tabAct = sessionStorage.getItem("doctorTab" ) || '/tradiIndexPage'  
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.box{
  width: 1100px !important;
  margin: 0 auto;
  padding: 20px 0 10px;
}
.topLine {
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  padding: 8px 9px;
  
}

.topLine .l {
  display: flex;
}

.topLine img {
  width: 32px;
  height: 32px;
  margin-right: 14px;
}

.topLine h5 {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #666666;
}

.topLine p {
  font-size: 10px;
  color: #999999;
}
.tabs,
.r{
  margin-left: 14px;
  display: flex;
} 
.tabs .el-link{
  margin:0 10px;
}
.tabs .el-link.act{
  color:#f64420;
  position: relative;
}
.tabs .el-link.el-link--default:hover{
  color:#f64420;
} 
.tabs .el-link.is-underline:hover:after{
  /* border-color:#f64420; */
  border-color:transparent;
} 
</style>


// WEBPACK FOOTER //
// src/components/traditionalAndWest/topNav.vue